import Vue from 'vue';
import format from 'date-fns/format';

Vue.filter('formatDateWithHours', (value) => {
  if (value) {
    return format(String(value), 'DD/MM/YYYY [às] HH:mm');
  }
  return '';
});

Vue.filter('formatDate', (value) => {
  if (value) {
    return format(String(value), 'DD/MM/YYYY');
  }
  return '';
});



// WEBPACK FOOTER //
// ./src/filters/formatDate.js